import { MAX_CONTENT_PER_CAMPAIGN } from "../../../constants";
import { showAlertPopUp } from "../../utils/Overlay";

export function verifyMaxNumberOfContentItems(content?: Content[]) {
  if (content && content.length >= MAX_CONTENT_PER_CAMPAIGN) {
    showAlertPopUp(
      `You reached the maximum number of content items per campaign (${MAX_CONTENT_PER_CAMPAIGN}). Either create a new campaign or delete some of the existing items.`
    );
    return false;
  }
  return true;
}
